import AppRecord from './AppRecord.js'
class InvoiceTypeInterval extends AppRecord {
  get controller_name(){
    return 'InvoiceTypeIntervalsController'
  }

  readIntervalLines(){
    const q = {
      q: {
        where: {
          invoice_type_interval_id: this.id
        }
      }
    }
    this.constructor.employeeStore.GET_INVOICE_TYPE_INTERVAL_LINES(q)
  }

  get invoice_type_interval_lines(){
    if (this.constructor.employeeStore.invoice_type_interval_lines){
      return this.constructor.employeeStore.invoice_type_interval_lines.filter(x => x.invoice_type_interval_id == this.id)
    }

    return []
  }
}

export default InvoiceTypeInterval
